import PropTypes from "prop-types";

import ActionButton from "../../../formInputs/buttons/ActionButton";

const OverallComments = ({
    currentTimePeriodDto,
    isActiveAndIsUnreleased,
    profileComment,
    saveStudentOverallComment,
    setStudentOverallComment,
    student,
    studentOverallComment
}) => {
    if (!student) return null;
    return (
        <section className="section-card">
            <header className="section-card__header">
                <h5 className="section-card__title">{currentTimePeriodDto?.name || ""} Overall Comments</h5>
            </header>
            <div className="section-card__body comments-stack">
                <section className="comment-card">
                    <header className="comment-card__header">
                        <p className="comment-card__title">Class Comment (to all parents/guardians):</p>
                    </header>
                    <div className="comment-card__body">
                        <p style={{ whiteSpace: "pre-line" }}>
                            {profileComment ? (
                                profileComment
                            ) : (
                                <span style={{ fontStyle: "italic" }}>No comment entered</span>
                            )}
                        </p>
                    </div>
                </section>
                {/* ===== Overall student comment ===== */}
                <div className="comment-card">
                    <div className="comment-card__title">
                        {student.firstName} {student.lastName}&apos;s Semester Comment
                    </div>
                    <textarea
                        className="comment-textarea"
                        disabled={!isActiveAndIsUnreleased}
                        rows={4}
                        value={studentOverallComment || ""}
                        onChange={(e) => setStudentOverallComment(e.target.value)}
                        placeholder={`Add an overall comment for ${student.firstName}…`}
                    />
                    <div className="comment-actions">
                        <ActionButton
                            disable={!isActiveAndIsUnreleased}
                            label={`Save ${student.firstName}'s Comment`}
                            onClick={saveStudentOverallComment}
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};

OverallComments.propTypes = {
    isActiveAndIsUnreleased: PropTypes.bool,
    currentTimePeriodDto: PropTypes.shape({
        name: PropTypes.string
    }),
    profileComment: PropTypes.string,
    saveStudentOverallComment: PropTypes.func.isRequired,
    setStudentOverallComment: PropTypes.func.isRequired,
    student: PropTypes.shape({
        firstName: PropTypes.string.isRequired,
        lastName: PropTypes.string.isRequired,
        studentNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    }).isRequired,
    studentOverallComment: PropTypes.string.isRequired
};
OverallComments.defaultProps = {
    isActiveAndIsUnreleased: false
};

export default OverallComments;
